import { fetchGet } from '@/api/http.js';

const getCheckMobileReg = function() {
  return new Promise((resolve, reject) => {
    fetchGet('/saas/pub/smsVerifyCode/getReg', {}).then((res) => {
      let regStr = decodeURIComponent(res.encode || '');
      let modifierStr = '';
      const modifierMatch = regStr.match(/([\i\g\m\I\G\M]+$)/);
      if (modifierMatch) {
        modifierStr = modifierMatch[0];
        regStr = regStr.slice(0, modifierMatch.index);
      }
      const checkMobileReg = regStr.replace(/(^\/)|(\/$)/g, '');
      resolve(new RegExp(checkMobileReg, modifierStr));
    }).catch(err => {
      reject(err);
    });
  });
};

export default getCheckMobileReg;